

const FormField = ({ label, type = "text", placeholder, options = [], value = "", onChange, valKey, validationErr, valueKey = 'value', labelKey = 'label' }) => (
    <div className="form-field">
        {label && <label>{label}</label>}
        {type === "select" ? (
            <>
                <select className="input" value={value}
                    onChange={(e) => onChange(valKey, e.target.value)}
                >
                    <option value="">{placeholder}</option>
                    {options.map((opt) => (
                        <option key={opt[valueKey]} value={opt[valueKey]}>
                            {opt[labelKey]}
                        </option>
                    ))}
                </select>
                {
                    validationErr && <p className="text-danger ml-1 fw-bold" style={{ fontSize: "11px" }}>{validationErr}</p>
                }
            </>
        ) : (
            <>
                <input type={type} placeholder={placeholder} className="input"
                    value={value}
                    onChange={(e) => onChange(valKey, e.target.value)}
                />
                {
                    validationErr && <p className="text-danger ml-1 fw-bold" style={{ fontSize: "11px" }}>{validationErr}</p>
                }
                <p></p>
            </>
        )}
    </div >
);


export default FormField